'use strict';

require('../modules/forms/forms');

require('../helpers/show-modal-message/show-modal-message');

angular.module('far.forms.tokenUsersForm', [
	'dekky.forms',
	
	'far.helpers.showModalMessage'
])
.service('tokenUsersForm', function(form, autocomplete, fileUploadFilters, showModalMessage) {
	var tokenUsersModel = form('tokenUsersModel');
tokenUsersModel
	
		.addField('documents', 'hidden')
		
       

		.addField('documentsFiles', 'fileUpload', {
			validators: { required: true },
			label: 'Загрузить документ',
			uploader: {
				url: Routing.generate('api_upload_post_file'),
				autoUpload: true,
				filters: [
					fileUploadFilters.fileSize(),
					fileUploadFilters.fileType()
				],
				// onSuccessItem: function (item, response) {
				// 	item.serverData = response;
				// },
				onWhenAddingFileFailed: function(item, filter) {
					var message = filter.message ? filter.message : 'Невозможно загрузить файл на сервер';
					showModalMessage(message);
				}
			}
		});

	return tokenUsersModel;
});